










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import TestReportTable from '@/components/test_report/TestReportTable.vue';

@Component({
  components: {
    Header,
    TestReportTable,
    Footer,
  },
})
export default class TestReportList extends Vue {}
